import React from 'react';
import { Link } from 'react-router-dom';
import { Smartphone } from '@/components/DeskeyIcons';

const APP_NAMES = {
  teacher: 'Deskey Teacher',
  student: 'Deskey Student',
};

/** "Get the app" card under the teacher / student login form. */
export default function MobileAppPromo({ role, accent }) {
  const appName = APP_NAMES[role];
  if (!appName) return null;

  return (
    <div className="mt-6 flex items-center gap-3 rounded-xl border border-gray-200 bg-white px-4 py-3" data-testid={`mobile-app-promo-${role}`}>
      <div className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0" style={{ background: `${accent}1A`, color: accent }}>
        <Smartphone className="w-4 h-4" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-xs font-semibold text-gray-900">Get the {appName} app</p>
        <p className="text-[11px] text-gray-500">Available for Android</p>
      </div>
      <Link to={`/get-app/${role}`} className="shrink-0 rounded-lg px-3 py-1.5 text-xs font-semibold text-white" style={{ background: accent }} data-testid="mobile-app-download">
        Download
      </Link>
    </div>
  );
}
